import Vue from 'vue'
import App from './App.vue'
import router from './router'
// element ui css样式
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/index.scss'
Vue.config.productionTip = false
import element from './element/index.js'
Vue.use(element)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
